// Configurazione stati + helper condivisi per le pratiche di vendita bici.
// Stile allineato a NLT: badge a gradiente glass, accento emerald.

export const ORDINE_STATI = ['preventivo', 'confermata'];

// Badge a gradiente come in PratichePage NLT (classi complete per il build Tailwind)
export const STATI = {
  preventivo: { label: 'Preventivo', badge: 'bg-gradient-to-r from-amber-50/80 to-amber-100/60 text-amber-700 border-amber-200/50', dot: 'bg-amber-500' },
  confermata: { label: 'Confermata', badge: 'bg-gradient-to-r from-emerald-50/80 to-emerald-100/60 text-emerald-700 border-emerald-200/50', dot: 'bg-emerald-500' }
};

export const statoInfo = (s) => STATI[s] || STATI.preventivo;

// Il prezzo negozio è salvato IVA esclusa: per l'uso lo maggioriamo del 22%.
export const IVA_NEGOZIO = 1.22;
export const prezzoNegozioConIva = (v) => (v === null || v === undefined || v === '') ? null : Number(v) * IVA_NEGOZIO;

// ---- Provvigioni -----------------------------------------------------------
// Margine = Prezzo Pubblico (vendita, IVA incl.) − Prezzo Negozio (costo, IVA escl.)
// = 100% della provvigione. L'agente ne prende una percentuale fissa.
export const calcolaProvvigioni = (prezzoPubblico, prezzoNegozio, percentuale) => {
  const pub = Number(prezzoPubblico) || 0;
  const neg = Number(prezzoNegozio) || 0;
  const perc = Number(percentuale) || 0;
  const margine = pub - neg;
  const provvigioneAgente = margine * perc / 100;
  const provvigioneAzienda = margine - provvigioneAgente;
  return { margine, provvigioneAgente, provvigioneAzienda, percentuale: perc };
};

export const prossimoStato = (s) => {
  const i = ORDINE_STATI.indexOf(s);
  if (i === -1 || i === ORDINE_STATI.length - 1) return null;
  return ORDINE_STATI[i + 1];
};

export const formatEuro = (v, dash = '—') => {
  if (v === null || v === undefined || v === '') return dash;
  const n = Number(v);
  if (isNaN(n)) return dash;
  return '€ ' + n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatData = (d) => {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }); }
  catch (e) { return '—'; }
};

export const formatDataOra = (d) => {
  if (!d) return '';
  try {
    return new Date(d).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch (e) { return ''; }
};

export const clienteNome = (c) => {
  if (!c) return 'Cliente';
  if (c.ragione_sociale) return c.ragione_sociale;
  const n = `${c.nome || ''} ${c.cognome || ''}`.trim();
  return n || c.email || 'Cliente';
};

export const clienteIniziali = (c) => {
  const nome = clienteNome(c);
  const parts = nome.split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (nome.slice(0, 2) || '??').toUpperCase();
};

export const metodoPagamentoLabel = {
  contanti: 'Contanti',
  bonifico: 'Bonifico',
  carta: 'Carta',
  finanziamento: 'Finanziamento',
  altro: 'Altro'
};

// Badge di stato in stile NLT
export const StatoPill = ({ stato, size = 'md', className = '' }) => {
  const info = statoInfo(stato);
  const sz = size === 'sm' ? 'px-3 py-1 text-xs' : 'px-4 py-2 text-sm';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-xl font-semibold border backdrop-blur-sm ${sz} ${info.badge} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${info.dot}`} />
      {info.label}
    </span>
  );
};
